import { useEffect, useRef } from "react"
import { useAppDispatch, useAppSelector } from "@/store"
import { TAGS } from "@/store/api"
import { deckEndpoints } from "@/store/apis/deckAPI"
import { effectsEndpoints } from "@/store/apis/effectsAPI"
import { gameplayEndpoints } from "@/store/apis/gameplayAPI"
import { GameplaySelectors } from "@/store/slices/gameplay"

const RECONCILE_DEBOUNCE_MS = 300

export const useGameplayReconciler = (): void => {
  const dispatch = useAppDispatch()
  const sessionId = useAppSelector(GameplaySelectors.selectSessionId())
  const isMatchFinished = useAppSelector(
    GameplaySelectors.selectIsMatchFinished()
  )
  const isSocketConnected = useAppSelector(
    GameplaySelectors.selectSocketConnection()
  )

  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    const handler = () => {
      if (timerRef.current) clearTimeout(timerRef.current)
      timerRef.current = setTimeout(() => {
        timerRef.current = null
        if (!sessionId) return
        if (isMatchFinished) return
        if (!isSocketConnected) return
        if (document.hidden) return

        console.warn(
          `[gameplay-resilience] visibility/online refetch (sessionId=${sessionId})`
        )
        dispatch(
          gameplayEndpoints.util.invalidateTags([{ type: TAGS.GAMEPLAY }])
        )
        dispatch(deckEndpoints.util.invalidateTags([{ type: TAGS.DECK }]))
        dispatch(effectsEndpoints.util.invalidateTags([{ type: TAGS.EFFECTS }]))
      }, RECONCILE_DEBOUNCE_MS)
    }

    document.addEventListener("visibilitychange", handler)
    window.addEventListener("online", handler)

    return () => {
      document.removeEventListener("visibilitychange", handler)
      window.removeEventListener("online", handler)
      if (timerRef.current) {
        clearTimeout(timerRef.current)
        timerRef.current = null
      }
    }
  }, [sessionId, isMatchFinished, isSocketConnected, dispatch])
}
